import React from 'react'
import { graphql } from 'gatsby'

// components
import RoleTwo from '../components/templates/RoleTwo'

// template
const roleTwoOwner = (props) => {
  return <RoleTwo data={props.data} pageContext={props.pageContext} />
}

export default roleTwoOwner

// script
export const pageQuery = graphql`
  query($skip: Int, $limit: Int, $target: String, $catOne: String) {
    currentRole: markdownRemark(
      frontmatter: { kind: { eq: "role" }, cat: { eq: "owner" } }
    ) {
      id
      fields {
        slug
      }
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }

    currentPost: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: {
          kind: { eq: "faq" }
          posttype: { eq: "post" }
          owner: { nin: ["×"] }
        }
        fields: { slug: { regex: $target } }
      }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            kind
            posttype
            cat
            order
            title
            date
            owner
            subowner
            manager
            user
            nyuko
          }
        }
      }
    }

    currentCatOne: markdownRemark(
      frontmatter: {
        kind: { eq: "faq" }
        posttype: { eq: "catOne" }
        cat: { eq: $catOne }
      }
    ) {
      id
      fields {
        slug
      }
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }

    currentAllPost: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: {
          kind: { eq: "faq" }
          posttype: { eq: "post" }
          owner: { nin: ["×"] }
        }
        fields: { slug: { regex: $target } }
      }
    ) {
      totalCount
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            kind
            posttype
            cat
            order
            title
            date
            owner
            subowner
            manager
            user
            nyuko
          }
        }
      }
    }
  }
`
